import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import PrefixContext from '../contexts/PrefixContext'
import useName from '../hooks/use-name'

function Prefix (props) {
  const name = useName(props.name)

  return (
    <PrefixContext.Provider value={name}>
      {props.children}
    </PrefixContext.Provider>
  )
}

Prefix.defaultProps = {
  name: null
}

Prefix.propTypes = {
  name: PropTypes.string.isRequired
}

export default observer(Prefix)
